/**
 * Freetimers Digital - Main JavaScript
 * Mobile menu, dropdowns, and interactive behaviors
 */

document.querySelectorAll('[data-wp-on--focusout]').forEach(el => {
  el.removeAttribute('data-wp-on--focusout');
});

(function () {
  'use strict';

  // ===========================
  // Mobile Menu Toggle
  // ===========================
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const iconOpen = document.getElementById('menu-icon-open');
  const iconClose = document.getElementById('menu-icon-close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');

      if (iconOpen && iconClose) {
        iconOpen.style.display = isOpen ? 'none' : 'block';
        iconClose.style.display = isOpen ? 'block' : 'none';
      }
    });

    // Close menu when clicking a link
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {

        if (this.parentElement.classList.contains('menu-item-has-children')) {
          return;
        }

        mobileMenu.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        if (iconOpen && iconClose) {
          iconOpen.style.display = 'block';
          iconClose.style.display = 'none';
        }
      });
    });
  }

  // ===========================
  // Desktop Dropdown Navigation
  // ===========================
  document.querySelectorAll('.nav-dropdown').forEach(function (dropdown) {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.nav-dropdown-menu');

    if (!toggle || !menu) return;

    // Mouse events
    dropdown.addEventListener('mouseenter', function () {
      dropdown.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
    });

    dropdown.addEventListener('mouseleave', function () {
      dropdown.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    });

    // Click toggle (touch devices)
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = dropdown.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    // Keyboard: Escape to close
    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dropdown.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });

  // ===========================
  // Mobile Dropdown Submenus
  // ===========================
  document.querySelectorAll('.mobile-nav .menu-item-has-children > a')
      .forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();

          const parent = this.parentElement;
          const submenu = this.nextElementSibling;

          if (!submenu) return;

          const isOpen = submenu.classList.toggle('open');
          this.setAttribute('aria-expanded', isOpen);

          // Optional: close siblings
          parent.parentElement.querySelectorAll('.menu-item-has-children')
              .forEach(function (item) {
                if (item !== parent) {
                  item.querySelector('.sub-menu')?.classList.remove('open');
                  item.querySelector('a')?.setAttribute('aria-expanded', 'false');
                }
              });
        });
      });

  // ===========================
  // Footer Collapsible Sections (Mobile)
  // ===========================
  document.querySelectorAll('[data-collapsible-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const target = document.getElementById(this.dataset.collapsibleTarget);
      if (target) {
        const isOpen = target.classList.toggle('open');
        this.setAttribute('aria-expanded', isOpen);
        const chevron = this.querySelector('.chevron');
        if (chevron) {
          chevron.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      }
    });
  });

  // ===========================
  // Animated Count-Up on Scroll
  // ===========================
  function animateCountUp(el) {
    const target = parseInt(el.dataset.countTarget, 10);
    const prefix = el.dataset.countPrefix || '';
    const suffix = el.dataset.countSuffix || '';
    const duration = 2000;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(target * eased);
      el.textContent = prefix + current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  // Intersection Observer for count-up animations
  if ('IntersectionObserver' in window) {
    const countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-count-target]').forEach(animateCountUp);
          countObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('[data-count-section]').forEach(function (section) {
      countObserver.observe(section);
    });
  }

  // ===========================
  // Accessibility: Text Size Controls
  // ===========================
  window.setTextSize = function (size) {
    document.documentElement.className = document.documentElement.className
      .replace(/text-size-\w+/g, '')
      .trim();
    if (size !== 'normal') {
      document.documentElement.classList.add('text-size-' + size);
    }
    try {
      localStorage.setItem('ft-text-size', size);
    } catch (e) { /* silent */ }
  };

  // Restore saved text size
  try {
    const saved = localStorage.getItem('ft-text-size');
    if (saved && saved !== 'normal') {
      document.documentElement.classList.add('text-size-' + saved);
    }
  } catch (e) { /* silent */ }

})();
